import React from 'react';
import { ActivateAccount } from '~/features/club/components';
import { P200ActivationPage as P200ActivationPageType } from '~/lib/data-contract';
import { Container } from '~/templates/blocks/components/container/container.component';
import { usePage } from '~/templates/pages';
import { StyledActivationContent } from '~/templates/pages/components/P200ActivationPage/styled';

export const P200ActivationPage = () => {
    const { description, newsletterConsent } = usePage<P200ActivationPageType>();

    return (
        <Container hasGutter>
            <StyledActivationContent>
                <ActivateAccount newsletterConsent={newsletterConsent} description={description} />
            </StyledActivationContent>
        </Container>
    );
};
